var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33.97,
  height: 48.22,
  viewBox: "0 0 33.97 48.22",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "unlock")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.45,24.89H10.24V11.68a6.75,6.75,0,1,1,13.49,0v7.39h4.93V11.68a11.68,11.68,0,0,0-23.36,0V24.89H1.52A1.52,1.52,0,0,0,0,26.41V46.7a1.52,1.52,0,0,0,1.52,1.52H32.45A1.52,1.52,0,0,0,34,46.7V26.41A1.52,1.52,0,0,0,32.45,24.89Z",
  fill: "currentColor"
})))));
export default SvgUnlock;